<template>
  <!-- Modal -->
  <div
    class="modal fade"
    id="skyTvModal"
    tabindex="-1"
    aria-labelledby="skyTvModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-lg modal-dialog-scrollable">
      <div class="modal-content">
        <!-- Modal Header -->
        <div class="modal-header">
          <h5 class="modal-title fw-normal" id="skyTvModalLabel">
            List of SkyTV Channels
          </h5>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          ></button>
        </div>

        <!-- Modal Body -->
        <div class="modal-body fw-normal">
          <div class="row">
            <div class="col-md-4">
              <ul>
                <li>A2Z</li>
                <li>ABC AUSTRALIA</li>
                <li>ADVISORY CHANNEL</li>
                <li>AL JAZEERA</li>
                <li>ALIW 23</li>
                <li>ALLTV</li>
                <li>ARIRANG</li>
                <li>BILYONARYO NEWS CHANNEL HD</li>
                <li>BS FUJI</li>
                <li>BS PREMIUM</li>
                <li>CCTV 4</li>
                <li>CGTN</li>
                <li>CHANNEL NEWS ASIA</li>
                <li>CINEMO</li>
                <li>CLTV</li>
                <li>DEUTSCHE WELLE (ENGLISH)</li>
                <li>DZRH NEWS</li>
                <li>EWTN</li>
                <li>FASHION TV</li>
                <li>FIBERTV LIVE</li>
              </ul>
            </div>
            <div class="col-md-4">
              <ul>
                <li>FRANCE 24</li>
                <li>GMA</li>
                <li>GNN TV44</li>
                <li>GTV</li>
                <li>HALLYPOP</li>
                <li>IBC 13</li>
                <li>INC TV</li>
                <li>JEEPNEY TV</li>
                <li>KAPAMILYA HD</li>
                <li>KNOWLEDGE CHANNEL</li>
                <li>LIGHT TV</li>
                <li>LOTUS MACAU HD</li>
                <li>MINDANOW HD</li>
                <li>MYX</li>
                <li>Net 25</li>
                <li>NHK BS1</li>
                <li>NHK WORLD JAPAN</li>
                <li>ONE SPORTS</li>
                <li>ORAS NG HIMALA</li>
                <li>PBO</li>
              </ul>
            </div>
            <div class="col-md-4">
              <ul>
                <li>PHOENIX CHINESE CHANNEL</li>
                <li>PTV</li>
                <li>RADIO MARIA</li>
                <li>RJTV</li>
                <li>ROCK TV OF MANILA</li>
                <li>RPTV</li>
                <li>SAUDI TV</li>
                <li>SMNI</li>
                <li>SOLAR FLIX</li>
                <li>SOLAR SPORTS</li>
                <li>Star Channel 1</li>
                <li>TBN</li>
                <li>TELERADYO SERBISYO</li>
                <li>TV MARIA</li>
                <li>TV5</li>
                <li>TV5MONDE</li>
                <li>TVE</li>
                <li>UNTV</li>
                <li>VIVA CINEMA</li>
                <li>XINGKONG</li>
              </ul>
            </div>
          </div>
        </div>

        <!-- Modal Footer -->
        <div class="modal-footer d-flex justify-content-center">
          <button
            type="button"
            class="btn close-btn px-5 fw-normal"
            data-bs-dismiss="modal"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "SkyTvModal",
};
</script>

<style scoped>
.close-btn {
  background-color: #2d0f4b !important;
  color: white;
}
</style>
